// language=GraphQL
export const ALL_DATES_QUERY = `query Query($withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {
  dates: ratioTravelDates {
    id
    dateNo
    startDate
    endDate
    availabilityStatus @include(if: $withAvailabilityStatus) {
      id
      label
      status
      isDefaultStatus
      isDefaultWaitlistFallback
      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
        id
        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        label
        info
        switchToStatusInfo
        submitButtonLabel
      }
    }
    includesExtension
    extensionBaseDate @include(if: $withExtensionBaseDate) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withExtensionBaseDateExtension) {
        id
        label
        info
        travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withExtensionBaseDatePackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withExtensionBaseDateExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {
          id
        }
      }
    }
    extension @include(if: $withExtension) {
      id
      label
      info
      travelExtension @include(if: $withExtensionTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
    packageSettings @include(if: $withPackageSettings) {
      id
      ratioPackageNo
      price
      availabilityStatus
    }
    json
    extensions @include(if: $withExtensions) {
      id
      label
      info
      travelExtension @include(if: $withExtensionsTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionsTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionsTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_DATE_QUERY = `query Query($id: ID!, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {
  date: ratioTravelDate(id: $id) {
    id
    dateNo
    startDate
    endDate
    availabilityStatus @include(if: $withAvailabilityStatus) {
      id
      label
      status
      isDefaultStatus
      isDefaultWaitlistFallback
      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
        id
        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        label
        info
        switchToStatusInfo
        submitButtonLabel
      }
    }
    includesExtension
    extensionBaseDate @include(if: $withExtensionBaseDate) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withExtensionBaseDateExtension) {
        id
        label
        info
        travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withExtensionBaseDatePackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withExtensionBaseDateExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {
          id
        }
      }
    }
    extension @include(if: $withExtension) {
      id
      label
      info
      travelExtension @include(if: $withExtensionTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
    packageSettings @include(if: $withPackageSettings) {
      id
      ratioPackageNo
      price
      availabilityStatus
    }
    json
    extensions @include(if: $withExtensions) {
      id
      label
      info
      travelExtension @include(if: $withExtensionsTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionsTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionsTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_DATE_MUTATION = `
  mutation Mutation($input: CreateRatioTravelDateInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {
    date: createRatioTravelDate(input: $input) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
          id
          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        includesExtension
        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withExtensionBaseDateExtension) {
          id
          label
          info
          travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withExtensionBaseDateExtensions) {
          id
          label
          info
          travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {
            id
          }
        }
      }
      extension @include(if: $withExtension) {
        id
        label
        info
        travelExtension @include(if: $withExtensionTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
      packageSettings @include(if: $withPackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionsTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionsTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionsTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_DATE_MUTATION = `
  mutation Mutation($input: UpdateRatioTravelDateInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {
    date: updateRatioTravelDate(input: $input) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
          id
          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        includesExtension
        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withExtensionBaseDateExtension) {
          id
          label
          info
          travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withExtensionBaseDateExtensions) {
          id
          label
          info
          travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {
            id
          }
        }
      }
      extension @include(if: $withExtension) {
        id
        label
        info
        travelExtension @include(if: $withExtensionTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
      packageSettings @include(if: $withPackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionsTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionsTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionsTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_DATE_MUTATION = `
  mutation Mutation($input: DeleteRatioTravelDateInput) {
    deleteRatioTravelDate(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_DATE_MUTATION = `
  mutation Mutation($input: DeleteRatioTravelDateInput) {
    forceDeleteRatioTravelDate(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: addRatioTravelDatePackageSettingsInput) {
    addRatioTravelDatePackageSettings(input: $input) {
      id
      packageSettingsIds
    }
  }`

// language=GraphQL
export const REMOVE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: removeRatioTravelDatePackageSettingsInput) {
    removeRatioTravelDatePackageSettings(input: $input) {
      id
      packageSettingsIds
    }
  }`

// language=GraphQL
export const CREATE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: createRatioTravelDatePackageSettingsInput) {
    createRatioTravelDatePackageSettings(input: $input) {
      id
      packageSettingsIds
    }
  }`

// language=GraphQL
export const DELETE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelDatePackageSettingsInput) {
    deleteRatioTravelDatePackageSettings(input: $input) {
      id
      packageSettingsIds
    }
  }`

// language=GraphQL
export const ADD_DATE_EXTENSIONS_MUTATION = `
  mutation Mutation($input: addRatioTravelDateExtensionsInput) {
    addRatioTravelDateExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const REMOVE_DATE_EXTENSIONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelDateExtensionsInput) {
    removeRatioTravelDateExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const CREATE_DATE_EXTENSIONS_MUTATION = `
  mutation Mutation($input: createRatioTravelDateExtensionsInput) {
    createRatioTravelDateExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const DELETE_DATE_EXTENSIONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelDateExtensionsInput) {
    deleteRatioTravelDateExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const UPDATE_DATE_EXTENSIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelDateExtensionsOrderInput) {
    updateRatioTravelDateExtensionsOrder(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const DATES_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravelDates: Boolean = false, $withBookings: Boolean = false, $withRatioTravels: Boolean = false, $withTravelPricingRules: Boolean = false) {
  groupedDependents: ratioTravelDateDependents(id: $id) {
    ratioTravelDates @include(if: $withRatioTravelDates) {
      id
      dateNo
      startDate
      endDate
      includesExtension
      json
    }
    bookings @include(if: $withBookings) {
      id
      referenceNo
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      confirmationEmailSent
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived    }
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus    }
    travelPricingRules @include(if: $withTravelPricingRules) {
      id
      checkAccommodationTypes
      checkAccommodationAddons
      checkAgeGroups
      useAgeFilter
      checkDateRange
      startDate
      endDate
      checkTravelDate
    }
  }
}`
